/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  FeatureSetService,
  Wealthlane_AppServices_Features_FeatureSetFeatureDto,
  Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse,
} from '../../services/wealthlane-identity-services';

const usePostFeatureSet = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  | Wealthlane_AppServices_Features_FeatureSetFeatureDto
  | Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse
  | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (id != null && id !== '') {
        return await handleRequest(FeatureSetService.putApiIdentityFeatureSet(id, payload));
      }
      return await handleRequest(FeatureSetService.postApiIdentityFeatureSet(payload));
    },
    {
      onSuccess: async (
        response:
          | Wealthlane_AppServices_Features_FeatureSetFeatureDto
          | Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse
          | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getVendorFeatureSet');
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Feature Set ${id != null && id !== '' ? 'edited.' : 'added.'}`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostFeatureSet;
